import { render, staticRenderFns } from "./SigningComplete.vue?vue&type=template&id=5ddb1aff"
import script from "./SigningComplete.vue?vue&type=script&lang=ts"
export * from "./SigningComplete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports